import axios from 'axios'
import { config } from '../Config/config'


const locationService = {
    
    getAllSearch: (filter) => {
        // getAll: () => {
        const result = axios.post(config.apiUrl + '/locationFilterSearch', filter)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAll: (filter) => {
        // getAll: () => {
        const result = axios.post(config.apiUrl + '/locationFilter', filter)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllKeywords: (filter) => {
        // getAll: () => {
        const result = axios.post(config.apiUrl + '/locationFilterKeywords', filter)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllData: () => {
        // getAll: () => {
        const result = axios.get(config.apiUrl + '/location')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    addData: (data) => {
        const result = axios.post(config.apiUrl + '/location', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    editData: (data) => {
        const result = axios.put(config.apiUrl + '/location', data)
            // const result = axios.post(config.apiUrl+'/categoryById/60249f62c79df0c78d032ab5', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    editDataDelete: (data) => {
        const result = axios.put(config.apiUrl + '/locationDelete', data)
            // const result = axios.post(config.apiUrl+'/categoryById/60249f62c79df0c78d032ab5', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    getById: (id) => {
        const result = axios.get(config.apiUrl + '/locationById/' + id)
            //(+ id) => memanggil parameter
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    // getByCategoryId: (id) => {
    //     const result = axios.get(config.apiUrl + '/customerRelationByCategoryId/' + id)

    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //     return result
    // },

    // deleteData
    deleteData: (id) => {
        // deleteData: (data) => {
        const result = axios.delete(config.apiUrl + '/location/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    countData: (data) => {
        const result = axios.post(config.apiUrl + '/countLocation', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    cekWilayahByNameLocation: (data) => {
        const result = axios.get(config.apiUrl + '/cekWilayahByNameLocation/'+ data)
        // const result = axios.post(config.apiUrl + '/cekUserByEmail'+ data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    cekWilayahByNameParent: (data) => {
        const result = axios.get(config.apiUrl + '/cekWilayahByNameParent/'+ data)
        // const result = axios.post(config.apiUrl + '/cekUserByEmail'+ data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    cekWilayahByName: (data) => {
        // const result = axios.get(config.apiUrl + '/cekWilayahByName/'+ data)
        const result = axios.post(config.apiUrl + '/cekWilayahByName', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    cekWilayahByNameEdit: (data) => {
        // const result = axios.get(config.apiUrl + '/cekWilayahByName/'+ data)
        const result = axios.post(config.apiUrl + '/cekWilayahByNameEdit', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

}

export default locationService
